import { Sparkles } from "lucide-react";

/**
 * Subtle "Recently launched / featured on" credibility strip.
 * Shown below the hero CTAs. Items are configurable — replace placeholders
 * with real launches as they happen.
 *
 * Each item: { label, href, badge? }
 *  - label: short text e.g. "Featured on Product Hunt"
 *  - href:  link target (opens in new tab)
 *  - badge: optional pill text e.g. "NEW"
 */
const ITEMS = [
    {
        label: "Now live · Start free for 60 days",
        href: "/pricing",
        badge: "LIVE",
        external: false,
    },
    // Add real entries as they happen, e.g.:
    // { label: "Featured on Product Hunt", href: "https://producthunt.com/...", external: true },
    // { label: "Read the founder note on LinkedIn", href: "https://linkedin.com/in/...", external: true },
];

export default function LaunchStrip() {
    if (!ITEMS.length) return null;

    return (
        <div data-testid="launch-strip" className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3">
            {ITEMS.map((item, i) => {
                const Tag = item.external ? "a" : "a";
                const props = item.external
                    ? { href: item.href, target: "_blank", rel: "noopener noreferrer" }
                    : { href: item.href };
                return (
                    <Tag
                        key={i}
                        data-testid={`launch-item-${i}`}
                        {...props}
                        className="group inline-flex items-center gap-2.5 text-xs sm:text-sm text-zinc-600 hover:text-zinc-900 transition-colors"
                    >
                        {item.badge && (
                            <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em]">
                                <span className="relative flex h-1.5 w-1.5">
                                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                                    <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-500" />
                                </span>
                                {item.badge}
                            </span>
                        )}
                        <Sparkles className="h-3.5 w-3.5 text-brand-primary opacity-70 group-hover:opacity-100" />
                        <span className="font-medium border-b border-dashed border-transparent group-hover:border-zinc-400">
                            {item.label}
                        </span>
                    </Tag>
                );
            })}
        </div>
    );
}
